import { kebabCase } from 'lodash';
function createFilterId() {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(kebabCase(name), "-filter");
}
export default createFilterId;
//# sourceMappingURL=createFilterId.js.map